var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgServiceRequest = function SvgServiceRequest(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 17.74,
    "data-width-28": 21,
    "data-width-72": 53,
    viewBox: "0 0 17.6 19.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.818 16.993c.51.46 1.188.707 1.882.707h2a.7.7 0 1 0 0-1.4h-2a1.42 1.42 0 0 1-.946-.348A1.01 1.01 0 0 1 1.4 15.2V2.5c0-.267.117-.54.354-.752.24-.216.579-.348.946-.348h12c.367 0 .706.132.946.348.237.213.354.485.354.752v3.7a.7.7 0 1 0 1.4 0V2.5c0-.688-.304-1.331-.817-1.793A2.82 2.82 0 0 0 14.7 0h-12C2.006 0 1.328.247.818.707A2.41 2.41 0 0 0 0 2.5v12.7c0 .688.304 1.331.818 1.793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 4.7a.7.7 0 0 1 .7-.7h5.5a.7.7 0 1 1 0 1.4H2.7a.7.7 0 0 1-.7-.7M2 8.7a.7.7 0 0 1 .7-.7h2.5a.7.7 0 1 1 0 1.4H2.7a.7.7 0 0 1-.7-.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.304 11.517a2.88 2.88 0 0 0-1.5-3.79.973.973 0 0 0-1.279.506l-1.289 2.977a.3.3 0 0 1-.395.156l-1.838-.796a.3.3 0 0 1-.143-.388l1.289-2.978a.973.973 0 0 0-.506-1.279 2.88 2.88 0 0 0-3.79 1.5l-1.195 2.759a2.61 2.61 0 0 0 .95 3.21l-1.18 2.725a1.7 1.7 0 0 0 .878 2.232l1.117.49.003.001.003.002 1.109.473a1.7 1.7 0 0 0 2.228-.887l1.197-2.764a2.72 2.72 0 0 0 3.213-1.543zm-6.845.344-.03-.014-.042-.018a.7.7 0 0 1-.12-.066 1.7 1.7 0 0 1-.692-2.138l1.094-2.528a1.48 1.48 0 0 0-1.532.884l-1.195 2.76a1.21 1.21 0 0 0 .63 1.59.94.94 0 0 1 .488 1.234l-1.347 3.11a.3.3 0 0 0 .155.394l1.114.489 1.106.472a.3.3 0 0 0 .393-.157l1.364-3.15a.95.95 0 0 1 1.277-.485 1.32 1.32 0 0 0 1.77-.672l1.127-2.605a1.48 1.48 0 0 0-.404-1.722l-1.094 2.528a1.7 1.7 0 0 1-2.236.884l-.47-.204-.01-.004-.01-.004z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgServiceRequest);
export default ForwardRef;